export default "__VITE_ASSET__DwS4rvLY__"